var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 203,
    viewBox: "0 0 197 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_661)",
    filter: "url(#filter0_d_16_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.545 98.0138C116.992 102.528 114.962 106.83 111.618 110.175C107.553 114.242 101.872 116.156 94.7367 115.868C89.7326 115.669 87.4216 116.978 87.042 117.216C85.5093 118.559 83.5634 119.294 81.5094 119.294C79.2632 119.294 77.1515 118.419 75.5635 116.832C72.8224 114.09 72.3804 109.862 74.2518 106.641L75.5948 104.512C76.0512 103.4 76.6686 101.204 76.5245 97.6559C76.2386 90.5185 78.1533 84.8393 82.2181 80.7745C85.5477 77.4473 89.8047 75.386 94.4076 74.8359C95.0587 71.7056 96.4688 68.7772 98.5036 66.3171H50.2211C44.9166 66.3171 40.5996 70.6318 40.5996 75.9362V123.645H140.97V76.2725L128.773 91.22C125.905 94.725 121.922 97.1106 117.545 98.0138V98.0138Z",
    fill: "url(#paint0_radial_16_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5996 133.927C40.5996 139.229 44.9166 143.543 50.221 143.543H77.5644V151.793H71.5038C69.5137 151.793 67.9002 153.406 67.9002 155.396C67.9002 157.387 69.5137 159 71.5038 159H110.065C112.055 159 113.668 157.387 113.668 155.396C113.668 153.406 112.055 151.793 110.065 151.793H104.004V143.543H131.348C136.653 143.543 140.97 139.229 140.97 133.927V130.852H40.5994V133.927H40.5996Z",
    fill: "url(#paint1_radial_16_661)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7468 109.953C80.746 109.953 80.7453 109.954 80.7448 109.954C80.7444 109.955 80.7441 109.955 80.7439 109.955L80.7429 109.956C80.7424 109.957 80.7422 109.957 80.7417 109.958C80.7415 109.958 80.7412 109.958 80.7405 109.959L80.7403 109.959C80.74 109.959 80.7395 109.96 80.7391 109.96C80.7391 109.96 80.7391 109.96 80.7388 109.96C80.7386 109.961 80.7381 109.961 80.7379 109.962C80.7379 109.962 80.7379 109.962 80.7376 109.962C80.7371 109.962 80.7369 109.963 80.7364 109.963C80.7364 109.963 80.7364 109.963 80.7362 109.963L80.735 109.965C80.2795 110.435 80.2841 111.185 80.7484 111.65C80.9831 111.884 81.2904 112.001 81.5979 112.001C81.9025 112.001 82.2071 111.886 82.4409 111.656C82.5144 111.586 86.1532 108.222 95.1173 108.582C100.161 108.786 104.027 107.578 106.612 104.994C111.907 99.6981 111.907 91.0819 106.612 85.7864C104.046 83.2212 100.636 81.8083 97.008 81.8083C93.3802 81.8083 89.9696 83.2209 87.4044 85.7864C84.8204 88.3704 83.6127 92.2376 83.8155 97.2806C84.1778 106.294 80.7758 109.922 80.7484 109.951C80.7475 109.952 80.7472 109.952 80.7468 109.953V109.953Z",
    fill: "url(#paint2_linear_16_661)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.232 90.6049C119.582 89.901 121.698 88.5076 123.277 86.5786L127.881 80.9359L111.479 64.5337L105.86 69.1231C103.926 70.6991 102.528 72.8131 101.821 75.1626C105.535 76.0347 108.942 77.9253 111.707 80.6904C114.537 83.5204 116.379 86.9677 117.232 90.6049Z",
    fill: "url(#paint3_radial_16_661)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.236 38.1639C151.552 35.4804 147.31 35.2666 144.369 37.669L117.089 59.9514L132.461 75.3233L154.733 48.0281C157.133 45.0898 156.919 40.8473 154.236 38.1639V38.1639Z",
    fill: "url(#paint4_radial_16_661)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_661",
    x: -3,
    y: 0,
    width: 203,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_661",
    x: 76.3967,
    y: 81.8083,
    width: 38.1865,
    height: 38.1929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_661",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2805 72.3327) rotate(90) scale(68.8551 120.553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16_661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2803 133.805) rotate(90) scale(33.8086 120.553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_661",
    x1: 74.545,
    y1: 81.8516,
    x2: 102.045,
    y2: 103.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16_661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.903 67.2694) rotate(90) scale(31.3137 31.2998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_16_661",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.805 40.1263) rotate(90) scale(47.2306 47.216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(37 36)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/UI.985c55d192c59a2d1193713522dcdcbb.svg";
export { ForwardRef as ReactComponent };